import Vue from 'vue';
import EventBus from '../components/event-bus';
export default {
//module.exports = {
    data() {
        return {
            currentEnvironment: false,
            role: {
                id: '',
                name: '',
            },
            system_year: "",
            persmission: "null",
            isLoggedIn: false,
            isBackend: false,
        }
    },
    created() {
        /*console.log("mixin created");*/
    },
    beforeMount() {

    },
    mounted: function () {
        if (process.env.NODE_ENV == 'production') {
            this.currentEnvironment = false;
        } else {
            this.currentEnvironment = true;
        }
        if (window.location.href.indexOf("/resetpassword") > -1 && window.location.href.indexOf("/login") > -1 && window.location.href.indexOf("/forgotpassword") > -1) {
            $(".app-sidebar-right").css("padding-left", "0px");
            $(".app-sidebar-right").css("margin-top", "0px");
            $(".app-sidebar-right").css({"-webkit-transition": "all 0.0s ease", "-moz-transition": "all 0.0s ease", "-o-transition": "all 0.0s ease", "transition": "all 0.0s ease"});
            $(".loginbg").show();
        } else {
            $(".app-sidebar-right").removeAttr("style");
            $(".loginbg").hide();
        }
    },
    methods: {
        /*storeFilters: function (listType, pageFilters) {
         var attributes = {};
         attributes[listType] = pageFilters;
         window.localStorage.setItem("filters", JSON.stringify(attributes));
         },*/
        storeFilters: function (listType, pageFilters, clear) {
            if (typeof clear === 'undefined' || clear === null) {
                clear = false;
            }
            /*console.log(listType);
             console.log(pageFilters);
             console.log(clear);*/
            var getfilters = {};
            if (!clear) {
                var filterObj = localStorage.getItem("filters");
                if (filterObj != null) {
                    getfilters = JSON.parse(filterObj);
                }
            }
            getfilters[listType] = pageFilters;
            window.localStorage.setItem("filters", JSON.stringify(getfilters));
        },
        downloadFile: function (href) {
                if ($('#DynDownloadAnchor').length) {
                    $('#DynDownloadAnchor').remove();
                }
                var anchor = document.createElement('a');
                anchor.id = "DynDownloadAnchor";
                anchor.style.display = "none";
                anchor.href = href;
                anchor.download = href;
                document.body.appendChild(anchor);
                anchor.click();
            },    
        loadFilters: function (listType, columns, serverParams, listClass) {
            if (typeof listClass === 'undefined' || listClass === null) {
                listClass = '';
            }
            var appliedFilters = localStorage.getItem('filters');
            if (appliedFilters != null) {
                appliedFilters = JSON.parse(appliedFilters);
                if (appliedFilters[listType] != null) {
                    serverParams.sort = appliedFilters[listType].sort;
                    serverParams.page = appliedFilters[listType].page;
                    serverParams.perPage = appliedFilters[listType].perPage;
                    serverParams.setCurrentPage = appliedFilters[listType].setCurrentPage;
                    serverParams.columnFilters = appliedFilters[listType].columnFilters;
                    $.map(appliedFilters[listType].columnFilters, function (val, key) {
                        $.each(columns, function (i) {
                            if (columns[i].field == key && val != '') {
                                let el = $('.' + listClass + ' *[placeholder="' + columns[i].filterOptions.placeholder + '"]');
                                el.val(val);
                                /*if (typeof columns[i].filterOptions.filterDropdownItems === 'undefined' || listClass === null) {
                                 }else{
                                 console.log("Select is available");
                                 $(listClass).each(function () {
                                 console.log("Select is available");
                                 console.log($(this).find(':input').length);
                                 });
                                 }*/
                                columns[i].filterOptions.filterValue = val;
                                /*Vue.set(columns[i].filterOptions,'filterValue',val);*/
                            }
                        });
                    });
                }
            }
        },
        showHidePagination: function (ListIdentifire, TotalData) {
            if (TotalData <= 0) {
                $('.' + ListIdentifire + ' .vgt-wrap__footer').hide();
            } else {
                $('.' + ListIdentifire + ' .vgt-wrap__footer').show();
            }
        },
        getRecords: function (serverPage, perPage, totalRecords) {
            serverPage = Number(serverPage);
            perPage = Number(perPage);
            totalRecords = Number(totalRecords);
            var firstLoad = true;
            var firstRecord = 0;
            var lastRecord = 0;

            var page = serverPage;
            for (var i = 1; i <= page; i++) {
                if (firstLoad == true) {
                    firstRecord = lastRecord + 1;
                    lastRecord = perPage;
                    firstLoad = false;
                } else {
                    firstRecord = lastRecord + 1;
                    lastRecord = (perPage * i);
                }
            }

            if (totalRecords != 0) {
                if (lastRecord > totalRecords) {
                    lastRecord = totalRecords;
                }
            } else if (totalRecords == 0) {
                firstRecord = 0;
                lastRecord = 0;
            }
            return firstRecord + " - " + lastRecord;
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
            $(".loading-container").hide();
            //}, 1700);
            let windowHeight = $(window).height();
            let headerHeight = $(".navbar-default").outerHeight();
            let contentHeight = $("#page-content-wrapper").outerHeight();
            let footerHeight = $(".admin-footer").outerHeight();
            if ((headerHeight + contentHeight) < windowHeight) {
                $(".admin-footer").removeAttr("style");
                /*alert(parseInt($(".admin-footer").css("marginTop").replace('px', '')));
                 alert(parseInt($(".admin-footer").css("marginBottom").replace('px', '')));*/
                /*alert("Window : " + $(window).height());
                 alert("navbar-default : " + $(".navbar-default").outerHeight());
                 alert("page-content-wrapper : " + $("#page-content-wrapper").outerHeight());
                 alert("admin-footer : " + $(".admin-footer").outerHeight());
                 /*alert("Margin will be : "+ Math.round(windowHeight -headerHeight - (contentHeight - footerHeight)-15));*/
                $(".admin-footer").css({"margin-top": Math.round(windowHeight - headerHeight - (contentHeight - footerHeight) - 10) + "px"});
            } else {
                $(".admin-footer").removeAttr("style");
            }
        },
        toggleButtons: function (activeBtn, activeClass, inactiveClass) {
            if (activeBtn == 'my') {
                $("." + inactiveClass).removeClass("btn-primary");
                $("." + inactiveClass).addClass("btn-secondary");
                $("." + activeClass).removeClass("btn-secondary");
                $("." + activeClass).addClass("btn-primary");
            } else {
                $("." + activeClass).removeClass("btn-secondary");
                $("." + activeClass).addClass("btn-primary");
                $("." + inactiveClass).removeClass("btn-primary");
                $("." + inactiveClass).addClass("btn-secondary");
            }
        },
        toggleButtonsCall: function (activeBtn, activeClass, inactiveClass) {
            if (activeBtn == 'normal') {
                $("." + inactiveClass).removeClass("btn-primary");
                $("." + inactiveClass).addClass("btn-secondary");
                $("." + activeClass).removeClass("btn-secondary");
                $("." + activeClass).addClass("btn-primary");
            } else {
                $("." + activeClass).removeClass("btn-secondary");
                $("." + activeClass).addClass("btn-primary");
                $("." + inactiveClass).removeClass("btn-primary");
                $("." + inactiveClass).addClass("btn-secondary");
            }
        },
        validAlphaDashComma : function (string) {
            return /^[a-zA-Z-,]+$/.test(string);
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/sessionmixin.js